import React from 'react'
import Book from "../components/Book";

function Livre() {
    return (
        <div>
            <Book/>
        </div>
    )
}

export default Livre
